import React from 'react';

const HostStyleContext = React.createContext<any>(undefined);

export default HostStyleContext;
